"use strict";

exports.__esModule = true;
exports.styleOut = exports.styleIn = void 0;
var _excluded = ["_ext"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var styleOut = function styleOut(output, originalInput, originalOutput) {
  return _extends({}, output, {
    _original: {
      input: _extends({}, originalInput),
      // 实际调用 api 方法时传入的参数. 对入参进行 format 之后的结果
      output: _extends({}, originalOutput) // 实际调用 api 方法时传入的参数. 返回值 format 之前的结果
    }
  });
};
exports.styleOut = styleOut;
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
    _ref$_ext = _ref._ext,
    _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return _extends({}, rest, _ext[baseName] || {});
};
exports.styleIn = styleIn;